<template>
  <v-app>
    <!-- App Bar adaptável para dispositivos móveis -->
    <v-app-bar app elevation="2" class="navbar-custom" :height="$vuetify.display.xs ? 'auto' : undefined">
      <template v-if="$vuetify.display.smAndDown">
        <!-- Layout mobile: logo centralizado em cima -->
        <div class="w-100 d-flex flex-column align-center py-2">
          <div class="mb-2 logo-container text-center">
            <span class="letra-m1">M</span><span class="letra-i">I</span><span class="letra-m2">M</span><span class="letra-o">O</span>
            <span class="letra-c">C</span><span class="letra-r">R</span><span class="letra-i2">I</span><span class="letra-a">A</span>
          </div>
          
          <!-- Botões de navegação em linha abaixo do logo -->
          <div class="d-flex justify-center w-100">
            <v-btn to="/" text class="nav-btn-mobile">
              <v-icon>mdi-home</v-icon>
              <span class="ml-1">Home</span>
            </v-btn>
            
            <v-btn to="/produtos" text class="nav-btn-mobile">
              <v-icon>mdi-view-grid</v-icon>
              <span class="ml-1">Produtos</span>
            </v-btn>
            
            <v-btn to="/carrinho" text class="nav-btn-mobile">
              <v-icon>mdi-cart</v-icon>
              <span class="ml-1">Carrinho</span>
              <v-badge
                :content="quantidadeItens.toString()"
                :value="quantidadeItens"
                color="accent"
                offset-x="5"
                offset-y="5"
              ></v-badge>
            </v-btn>
          </div>
        </div>
      </template>
      
      <template v-else>
        <!-- Layout desktop: logo à esquerda e menu à direita -->
        <v-app-bar-title class="font-weight-bold">
          <span class="letra-m1">M</span><span class="letra-i">I</span><span class="letra-m2">M</span><span class="letra-o">O</span>
          <span class="letra-c">C</span><span class="letra-r">R</span><span class="letra-i2">I</span><span class="letra-a">A</span>
        </v-app-bar-title>
        
        <v-spacer></v-spacer>
        
        <v-btn to="/" text class="nav-btn">
          <v-icon left>mdi-home</v-icon>
          Home
        </v-btn>
        
        <v-btn to="/produtos" text class="nav-btn">
          <v-icon left>mdi-view-grid</v-icon>
          Produtos
        </v-btn>
        
        <v-btn to="/carrinho" text class="nav-btn">
          <v-icon left>mdi-cart</v-icon>
          <span class="mr-1">Carrinho</span>
          <v-badge
            :content="quantidadeItens.toString()"
            :value="quantidadeItens"
            color="accent"
            offset-x="5"
            offset-y="5"
          ></v-badge>
        </v-btn>
      </template>
    </v-app-bar>
    
    <v-main>
      <v-container :class="$vuetify.display.smAndDown ? 'pt-6 px-2' : ''">
        <router-view />
      </v-container>
    </v-main>
    
    <v-footer app class="footer-custom" padless>
      <v-container>
        <v-row justify="center" no-gutters>
          <v-col cols="12" class="py-2 text-center">
            &copy; {{ new Date().getFullYear() }} — <strong> 
              <span class="letra-m1">M</span><span class="letra-i">I</span><span class="letra-m2">M</span><span class="letra-o">O</span>
              <span class="letra-c">C</span><span class="letra-r">R</span><span class="letra-i2">I</span><span class="letra-a">A</span>
            </strong>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'

export default {
  setup() {
    const store = useStore()
    
    onMounted(() => {
      // Carrega o carrinho do localStorage
      store.commit('carregarCarrinho')
    })
    
    // Calcula o número total de itens no carrinho
    const quantidadeItens = computed(() => {
      return store.state.carrinho.reduce((total, item) => total + item.quantidade, 0)
    })
    
    return {
      quantidadeItens
    }
  }
}
</script>

<style>
/* Correção para o conteúdo principal em dispositivos móveis */
.v-main {
  padding-top: 18px !important;
}

.v-application--is-ltr .v-app-bar--fixed {
  z-index: 999;
}

.v-container {
  transition: padding 0.3s ease;
}

.navbar-custom {
  background-color: #1e2b7c !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.navbar-custom .v-app-bar-title {
  font-size: 1.5rem;
  letter-spacing: 0.5px;
}

.nav-btn {
  font-weight: 500 !important;
  letter-spacing: 0.5px !important;
  margin: 0 5px !important;
  transition: all 0.3s ease !important;
}

.nav-btn:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
  transform: translateY(-2px);
}

.nav-btn-mobile {
  font-weight: 500 !important;
  font-size: 0.85rem !important;
  letter-spacing: 0.5px !important;
  margin: 0 2px !important;
  min-width: auto !important;
  padding: 0 8px !important;
}

.logo-container {
  font-size: 1.6rem !important;
  font-weight: bold !important;
  letter-spacing: 0.05em !important;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.1) !important;
}

.footer-custom {
  background-color: #1e2b7c !important;
  color: white !important;
}

.letra-m1 { color: #7cc576; /* Verde */ }
.letra-i { color: #f7941d; /* Laranja */ }
.letra-m2 { color: #f06e97; /* Rosa claro */ }
.letra-o { color: #1a9bd7; /* Azul claro */ }
.letra-c { color: #1a9bd7; /* Azul claro */ }
.letra-r { color: #f06e97; /* Rosa claro */ }
.letra-i2 { color: #f7941d; /* Laranja */ }
.letra-a { color: #7cc576; /* Verde */ }

.v-app-bar-title {
  font-size: 1.6rem !important;
  font-weight: bold !important;
  letter-spacing: 0.05em !important;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.1) !important;
}

/* Ajustes específicos para mobile */
@media (max-width: 600px) {
  .v-badge__badge {
    font-size: 9px !important;
    height: 16px !important;
    min-width: 16px !important;
    padding: 2px 4px !important;
  }
  
  /* Ajusta o padding do conteúdo principal para evitar sobreposição com a navbar */
  .v-main {
    padding-top: 42px !important; /* Ajuste conforme a altura da sua navbar em modo mobile */
  }
  
  /* Espaçamento adicional para o conteúdo */
  .v-container {
    padding-top: 8px !important;
    padding-bottom: 8px !important; /* Espaço para o footer */
  }
}
</style>